"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatedColumnModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const CalculatedColumnRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/CalculatedColumnRedux"));
const getExpressionViewItems_1 = require("./Utilities/getExpressionViewItems");
const CalculatedColumnWizard_1 = require("../View/CalculatedColumn/Wizard/CalculatedColumnWizard");
const ArrayExtensions_1 = tslib_1.__importDefault(require("../Utilities/Extensions/ArrayExtensions"));
const getObjectTagsViewItems_1 = require("./Utilities/getObjectTagsViewItems");
const getCalculatedColumnSettingsTags_1 = require("../View/CalculatedColumn/Utilities/getCalculatedColumnSettingsTags");
const Helper_1 = tslib_1.__importDefault(require("../Utilities/Helpers/Helper"));
class CalculatedColumnModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.CalculatedColumnModuleId, ModuleConstants.CalculatedColumnFriendlyName, 'chart-and-grid', 'CalculatedColumnPopup', 'Create bespoke columns whose cell value is derived dynamically from an Expression', api);
    }
    handleConfigReloaded(adaptableStateReloadedInfo) {
        // re-dispatch the CalculatedColumnReady action to recreate all the aggregated scalar columns
        this.api.internalApi.dispatchReduxAction(CalculatedColumnRedux.CalculatedColumnReady(this.api.calculatedColumnApi.getCalculatedColumnState()));
    }
    getModuleAdaptableObjects() {
        return this.api.calculatedColumnApi.getCalculatedColumns();
    }
    updateOldConfig() {
        const calcColumns = this.api.calculatedColumnApi.getCalculatedColumns();
        let oldCalculatedColumns = [];
        calcColumns.forEach((cc) => {
            if (cc.ColumnExpression && !cc.Query) {
                cc.Query = {
                    ScalarExpression: cc.ColumnExpression,
                };
                cc.ColumnExpression = undefined;
                oldCalculatedColumns.push(cc);
                this.api.logWarn(`Updating incorrect Predefined Config for Calculated Column: ${cc.ColumnId}`);
            }
            if (!cc.CalculatedColumnSettings) {
                cc.CalculatedColumnSettings = {
                    DataType: 'Number',
                };
                oldCalculatedColumns.push(cc);
                this.api.logWarn(`Updating incorrect Predefined Config for Calculated Column: ${cc.ColumnId}`);
            }
        });
        oldCalculatedColumns.forEach((oldCalcCol) => this.api.calculatedColumnApi.editCalculatedColumn(oldCalcCol));
    }
    getExplicitlyReferencedColumnIds(calculatedColumn) {
        var _a;
        return ((_a = this.api.expressionApi.getColumnsFromExpression(this.api.expressionApi.getAdaptableQueryExpression(calculatedColumn.Query))) !== null && _a !== void 0 ? _a : []);
    }
    getReferencedNamedQueryNames(calculatedColumn) {
        var _a;
        return ((_a = this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(this.api.expressionApi.getAdaptableQueryExpression(calculatedColumn.Query))) !== null && _a !== void 0 ? _a : []);
    }
    isCalculatedColumn(column) {
        return (column &&
            Helper_1.default.objectExists(this.api.calculatedColumnApi
                .getCalculatedColumns()
                .find((cc) => cc.ColumnId == column.columnId)));
    }
    addColumnMenuItems(column) {
        if (this.isModuleEditable() && this.isCalculatedColumn(column)) {
            return this.createEditCalculatedColumnMenuItem(column);
        }
    }
    addContextMenuItems(menuContext) {
        if (!this.isModuleAvailable()) {
            return;
        }
        if (this.isModuleEditable() &&
            this.isCalculatedColumn(menuContext.adaptableColumn) &&
            !menuContext.isRowGroupColumn &&
            menuContext.isSingleSelectedCell) {
            return this.createEditCalculatedColumnMenuItem(menuContext.adaptableColumn);
        }
    }
    createEditCalculatedColumnMenuItem(column) {
        let popupParam = {
            column: column,
            action: 'Edit',
            source: 'ColumnMenu',
        };
        return [
            this.createColumnMenuItemShowPopup('Edit Calculated Column', this.moduleInfo.Popup, this.moduleInfo.Glyph, popupParam),
        ];
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.calculatedColumnApi.getCalculatedColumns(),
            AddAction: CalculatedColumnRedux.CalculatedColumnAdd,
            EditAction: CalculatedColumnRedux.CalculatedColumnEdit,
        };
    }
    toView(calculateColumn) {
        const settingsTags = (0, getCalculatedColumnSettingsTags_1.getCalculatedColumnSettingsTags)(calculateColumn.CalculatedColumnSettings);
        let items = [
            {
                name: 'Settings',
                label: 'Column Id',
                values: [calculateColumn.ColumnId],
            },
            calculateColumn.FriendlyName && {
                name: 'Settings',
                label: 'Column Name',
                values: [calculateColumn.FriendlyName],
            },
            (0, getExpressionViewItems_1.getExpressionViewItems)(calculateColumn.Query, this.api),
        ].filter(Boolean);
        if (ArrayExtensions_1.default.IsNotNullOrEmpty(settingsTags)) {
            items.push({
                name: 'Settings',
                values: settingsTags,
            });
        }
        items.push((0, getObjectTagsViewItems_1.getObjectTagsViewItems)(calculateColumn, this.api));
        return {
            items: items,
            abObject: calculateColumn,
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((calculatedColumn) => this.toView(calculatedColumn));
    }
    getViewProperties() {
        return {
            getDeleteAction: CalculatedColumnRedux.CalculatedColumnDelete,
            getEditWizard: () => CalculatedColumnWizard_1.CalculatedColumnWizard,
        };
    }
}
exports.CalculatedColumnModule = CalculatedColumnModule;
